import * as React from "react"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { selectedBrands } from "../@signals"


// Filters by the brand of our SKU, not by the brand the retailer shows
export default function SkuDuplicatesBrandsFilter() {
    return <AutocompleteAsyncSeeker
        multiple
        urlAjax={`${BACKEND_APIS.BRANDS}/crud/brand/find-options`}
        label="SKU Brands"
        placeholder="Search Brands..."
        value={selectedBrands.value}
        onChange={e => selectedBrands.value = e.target.value}
        queryParam="search"
    />
}
